<div class="mon-chart">
    <div class="doughnut">
        <canvas [attr.height]="size"
                [attr.width]="size"
                class="chart chart-doughnut"
                chartBase
                [chartType]="'doughnut'"
                [chartData]="data"
                [chartLabels]="labels"
                [chartSeries]="series"
                [chartOptions]="options"
                [chartDatasetOverride]="override"
                [chartColors]="colors">
        </canvas>
    </div>
</div>
